import { makeStyles } from '../../../../styles';
export default makeStyles((theme) => ({
    root: {
        padding: '4px 8px',
        border: `1px solid ${theme.colors.gray[200]}`,
        borderRadius: theme.spacing(1),
        background: theme.colors.primary.contrastWhite,
        display: 'flex',
        justifyContent: 'space-between',
        '&:hover': {
            borderColor: theme.colors.primary.main,
            transition: '0.24s ease',
        },
    },
    inputWrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    input: {
        outline: 'none',
        textTransform: 'uppercase',
        marginLeft: 10,
        width: 100,
        border: 'none',
        color: theme.colors.text[900],
        fontSize: 14,
    },
    colorSwatch: {
        width: 30,
        height: 30,
        borderRadius: theme.spacing(1),
        background: '#F0F5FB',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    colorCircle: {
        width: 16,
        height: 16,
        borderRadius: 100,
    },
}));
//# sourceMappingURL=ColorInput.styles.js.map